export const federalRegisterTypeList = [
  { id: 1, value: '本号' },
  { id: 2, value: '号外' },
  { id: 3, value: '号外（物価版）' },
  { id: 4, value: '附録' },
  { id: 5, value: '附録（官報目録）' },
  { id: 6, value: '附録（物価版目録）' },
]
